import Swiper from 'swiper';
import { Navigation, Pagination, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/thumbs';

console.log('Single product gallery script loaded');

document.addEventListener('DOMContentLoaded', function() {
    setTimeout(initializeGallery, 200);
});

function initializeGallery() {
    console.log('Initializing custom Swiper gallery...');

    const galleryContainer = document.querySelector('.custom-swiper-gallery');
    const mainGallery = document.querySelector('.product-gallery-main');
    const thumbsGallery = document.querySelector('.product-gallery-thumbs');

    if (!mainGallery || !galleryContainer) {
        console.log('Required gallery elements not found');
        return;
    }

    // Reset any existing transforms and dimensions
    const mainContainer = mainGallery;
    const wrapper = mainContainer.querySelector('.swiper-wrapper');
    const slides = mainContainer.querySelectorAll('.swiper-slide');

    if (wrapper) {
        wrapper.style.transform = '';
        wrapper.style.transitionDuration = '';
        wrapper.style.width = '';
    }

    slides.forEach(slide => {
        slide.style.width = '';
        slide.style.marginRight = '';
        slide.style.transform = '';
    });

    mainContainer.style.width = '100%';
    mainContainer.style.height = 'auto';

    let thumbsSwiper = null;

    // Initialize thumbnails first if they exist
    if (thumbsGallery) {
        thumbsSwiper = new Swiper('.product-gallery-thumbs', {
            modules: [Thumbs],
            spaceBetween: 10,
            slidesPerView: 'auto',
            freeMode: true,
            watchSlidesProgress: true,
            observer: true,
            observeParents: true,
            breakpoints: {
                320: { slidesPerView: 3, spaceBetween: 8 },
                640: { slidesPerView: 4, spaceBetween: 10 },
                768: { slidesPerView: 5, spaceBetween: 12 },
                1024: { slidesPerView: 6, spaceBetween: 15 },
            }
        });
        console.log('Thumbnails swiper initialized');
    }

    // Wait a moment before initializing main swiper
    setTimeout(() => {
        const mainSwiperConfig = {
            modules: [Navigation, Pagination],
            spaceBetween: 0,
            slidesPerView: 1,
            loop: false,
            centeredSlides: false,
            observer: true,
            observeParents: true,
            watchOverflow: true,
            resistance: true,
            resistanceRatio: 0.85,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
                dynamicBullets: true,
            }
        };

        // Add thumbs connection if thumbnails exist
        if (thumbsSwiper) {
            mainSwiperConfig.modules.push(Thumbs);
            mainSwiperConfig.thumbs = {
                swiper: thumbsSwiper,
                slideThumbActiveClass: 'swiper-slide-thumb-active',
                thumbsContainerClass: 'swiper-container-thumbs',
                multipleActiveThumbs: false,
            };
        }

        const mainSwiper = new Swiper('.product-gallery-main', mainSwiperConfig);

        console.log('Main swiper initialized successfully!');

        // Manual thumbnail click handling as backup
        if (thumbsGallery && mainSwiper) {
            const thumbSlides = thumbsGallery.querySelectorAll('.swiper-slide');
            thumbSlides.forEach((thumb, index) => {
                thumb.addEventListener('click', () => {
                    console.log('Thumbnail clicked:', index);
                    mainSwiper.slideTo(index);
                });
            });
        }

        // Initialize lightbox functionality
        initializeLightbox(mainSwiper);

        // Force update after a short delay
        setTimeout(() => {
            mainSwiper.update();
            if (thumbsSwiper) {
                thumbsSwiper.update();
            }
            console.log('Swipers updated');
        }, 100);

    }, 50);
}

// Custom Lightbox Implementation
function initializeLightbox(mainSwiper) {
    // Create lightbox HTML
    const lightboxHTML = `
        <div class="product-lightbox" id="productLightbox">
            <div class="lightbox-overlay">
                <div class="lightbox-container">
                    <button class="lightbox-close">&times;</button>
                    <div class="swiper lightbox-swiper">
                        <div class="swiper-wrapper" id="lightboxWrapper">
                            <!-- Slides will be populated dynamically -->
                        </div>
                        <div class="swiper-button-next lightbox-next"></div>
                        <div class="swiper-button-prev lightbox-prev"></div>
                        <div class="swiper-pagination lightbox-pagination"></div>
                    </div>
                </div>
            </div>
        </div>
    `;

    // Add lightbox to page
    document.body.insertAdjacentHTML('beforeend', lightboxHTML);

    const lightbox = document.getElementById('productLightbox');
    const lightboxWrapper = document.getElementById('lightboxWrapper');
    const closeBtn = lightbox.querySelector('.lightbox-close');

    let lightboxSwiper = null;

    // Function to open lightbox
    function openLightbox(startIndex = 0) {
        // Populate lightbox with high-res images
        lightboxWrapper.innerHTML = '';

        const allImages = document.querySelectorAll('.product-gallery-main .swiper-slide img');
        allImages.forEach((img, index) => {
            const slide = document.createElement('div');
            slide.className = 'swiper-slide';

            const lightboxImg = document.createElement('img');
            lightboxImg.src = img.getAttribute('data-large_image') || img.src;
            lightboxImg.alt = img.alt;

            slide.appendChild(lightboxImg);
            lightboxWrapper.appendChild(slide);
        });

        // Show lightbox
        lightbox.classList.add('active');
        document.body.style.overflow = 'hidden';

        // Initialize lightbox swiper
        setTimeout(() => {
            if (lightboxSwiper) {
                lightboxSwiper.destroy(true, true);
            }

            lightboxSwiper = new Swiper('.lightbox-swiper', {
                modules: [Navigation, Pagination],
                spaceBetween: 0,
                slidesPerView: 1,
                loop: false,
                initialSlide: startIndex,
                keyboard: {
                    enabled: true,
                },
                navigation: {
                    nextEl: '.lightbox-next',
                    prevEl: '.lightbox-prev',
                },
                pagination: {
                    el: '.lightbox-pagination',
                    clickable: true,
                },
            });
        }, 50);
    }

    // Function to close lightbox
    function closeLightbox() {
        lightbox.classList.remove('active');
        document.body.style.overflow = '';
        if (lightboxSwiper) {
            lightboxSwiper.destroy(true, true);
            lightboxSwiper = null;
        }
    }

    // Event listeners
    closeBtn.addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', (e) => {
        if (e.target === lightbox || e.target.classList.contains('lightbox-overlay')) {
            closeLightbox();
        }
    });

    // ESC key to close
    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && lightbox.classList.contains('active')) {
            closeLightbox();
        }
    });

    // Add click handlers to main gallery images
    const mainGalleryLinks = document.querySelectorAll('.product-gallery-main .swiper-slide a');
    mainGalleryLinks.forEach((link, index) => {
        link.addEventListener('click', (e) => {
            e.preventDefault();
            openLightbox(index);
        });
    });
}
